import { ArrowType, LineType, PathCollapsingRule } from '@ardoq/api-types';
import { ardoqId } from '@ardoq/common-helpers';
import { colors } from '@ardoq/design-tokens';

export const createEmptyPathCollapsingRule = (): PathCollapsingRule => ({
  referenceTypeId: ardoqId(),
  path: [],
  displayText: '',
  isActive: true,
  referenceStyle: defaultCollapsedPathReferenceStyle,
});

export const defaultCollapsedPathReferenceStyle = {
  color: colors.black950,
  line: LineType.SOLID,
  lineEnding: ArrowType.BOTH,
  lineBeginning: ArrowType.NONE,
  svgStyle: null,
};
